<template>
  <div></div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    resultName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('system', ['routerStatusRedirect']),
  },
  async created() {
    console.log(`status check ${this.resultName}`)
    const data = await this.getCreditEvaluationsCurrent()
    if (Object.keys(data).length === 0) {
      const path = '/factoring/confirm'
      if (
        this.$route.path !== path &&
        this.$route.path !== '/factoring/evaluation' &&
        this.routerStatusRedirect
      ) {
        this.$router.replace(path)
      }
      return
    }
    this.$emit('emitNext', {
      name: this.resultName,
      result: true,
    })
  },
  methods: {
    ...mapActions('evaluation', ['getCreditEvaluationsCurrent']),
  },
}
</script>
